/**
 * Canonical guest-facing URLs — the SINGLE source of truth so QR codes and
 * invite links never drift apart across apps (organizer settings/dashboard,
 * guest Sahne, …).
 *
 * `base` is the web app's origin — `window.location.origin` in the guest app,
 * or `VITE_WEB_BASE_URL` in the organizer app.
 */
export function buildJoinUrl(base: string, slug: string): string {
  return `${base.replace(/\/+$/, "")}/${slug}/join`;
}

/**
 * QR-facing scan-redirect URL. The QR encodes THIS (not the join page); the
 * worker logs the scan at /j/:slug then 302s to buildJoinUrl. Keeping it separate
 * means the printed code can be re-pointed server-side later.
 */
export function buildScanUrl(base: string, slug: string): string {
  return `${base.replace(/\/+$/, "")}/j/${slug}`;
}

/**
 * Web uygulamasının yasal sayfaları — organizatör / admin panelleri ve e-postalar bu yollara bağlanır
 * (web `paths.ts` de bunları kullanır). Yollar İngilizce (2026-10-18: hiçbir link Türkçe değil).
 */
export const WEB_PRIVACY_PATH = "/privacy";
export const WEB_TERMS_PATH = "/terms";
